import { ReactNode } from 'react';
import ListyFilterBarDesktop from './ListyFilterBarDesktop';
import ListyFilterBarMobile from './ListyFilterBarMobile';

interface props {
  period: string;
  selected: string;
  setPeriod: (period: string) => void;
  isXs: boolean;
  children?: ReactNode;
}

export interface iProps extends props {
  sold: boolean;
  activeFilters: number;
}

const ListyFilterBar: React.FC<props> = (props) => {
  return props.isXs ? (
    <ListyFilterBarMobile period={props.period} selected={props.selected} setPeriod={props.setPeriod}>
      {props.children}
    </ListyFilterBarMobile>
  ) : (
    <ListyFilterBarDesktop period={props.period} selected={props.selected} setPeriod={props.setPeriod}>
      {props.children}
    </ListyFilterBarDesktop>
  );
};
export default ListyFilterBar;
